import { render } from "./SectionEdit.vue?vue&type=template&id=3a022210&scoped=true"
import script from "./SectionEdit.vue?vue&type=script&lang=js"
export * from "./SectionEdit.vue?vue&type=script&lang=js"

import "./SectionEdit.vue?vue&type=style&index=0&id=3a022210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a022210"]])

export default __exports__